// This exports variables from the top window to the siteadmin iframe

let features = require('diy/util/features');
let globalEvents = require('diy/util/globalEvents');
import {getString, getMessages} from 'diy/util/l10n';
let websiteData = require('diy/util/websiteData');
let helper = require('diy/util/helper');
let deeplinking = require('diy/util/deeplinking');
import color from 'diy/util/color';

let maintenanceMode = require('diy/maintenanceMode/maintenanceMode');
let MaintenanceModeWidget = require('diy/maintenanceMode/MaintenanceModeWidget');

let siteadminApi = require('./api');

let semanticDataRefresher = require('diy/semanticdata/refresher/refresher');
let semanticDataApi = require('diy/semanticdata/api/api');

let page = require('diy/page/page');

import {App} from 'diy/App';

declare var jimdoData: any;

export class IframeContext {
    constructor(private app: App) {

    }

    export() {
        return {
            jQuery: jQuery,
            jimdoData: jimdoData,
            uiPreference: diy.editor.uiPreference,
            deeplinking: deeplinking,
            features: features,
            globalEvents: globalEvents,
            l10n: {
                getString,
                getMessages
            },
            websiteData: websiteData,
            helper: helper,
            maintenanceMode: maintenanceMode,
            MaintenanceModeWidget: MaintenanceModeWidget,
            siteadminApi: siteadminApi,
            semanticDataApi: semanticDataApi,
            semanticDataRefresher: semanticDataRefresher,
            page: page,
            vCardEditor: this.app.vCardEditor,
            colorUtil: color
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/main/IframeContext.ts
 **/